import React from 'react';
import { aboutText, aboutImage } from '../mock';

const About = () => {
  return (
    <section id="om-oss" className="py-24 md:py-36 bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="reveal order-2 lg:order-1">
          <p className="text-[#8a8572] text-xs uppercase tracking-[0.4em] mb-5">
            — Om oss
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#2f3d30] leading-[1.05] mb-8">
            Hästen, fjället och <em className="italic font-light">stillheten</em>.
          </h2>
          <div className="space-y-5 text-[#4a4a45] text-[15px] md:text-base leading-relaxed font-light">
            {aboutText.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-10 flex items-center gap-6">
            <div>
              <p className="font-display text-3xl text-[#2f3d30]">20+</p>
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a8572] mt-1">
                Års erfarenhet
              </p>
            </div>
            <div className="w-px h-10 bg-[#d6ceba]" />
            <div>
              <p className="font-display text-3xl text-[#2f3d30]">4</p>
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a8572] mt-1">
                Platser per tur
              </p>
            </div>
            <div className="w-px h-10 bg-[#d6ceba]" />
            <div>
              <p className="font-display text-3xl text-[#2f3d30]">5</p>
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a8572] mt-1">
                Hästar i stallet
              </p>
            </div>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2 relative">
          <div className="relative img-zoom">
            <img
              src={aboutImage}
              alt="Lena with her horse"
              className="w-full h-[480px] md:h-[620px] object-cover"
            />
          </div>
          <div className="hidden md:block absolute -bottom-8 -left-8 bg-[#faf7f2] border border-[#e8e1d2] px-7 py-5 shadow-xl">
            <p className="font-display text-xl text-[#2f3d30] italic">Lena Selnert</p>
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a8572] mt-1">
              Grundare & Guide
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
